import swal from 'sweetalert';

const Alert = (text, type, title) => {
    swal(text, {
        icon: type || "success",
        title,
        buttons: {
            // cancel: "Cancel",
            Ok: true,
        },
        
    })
}

export default Alert;